var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',_vm._b({attrs:{"title":_vm.title,"to":_vm.route}},'router-link',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }